import { render, staticRenderFns } from "./RoomChat.vue?vue&type=template&id=1ad108a6&scoped=true&"
import script from "./RoomChat.vue?vue&type=script&lang=js&"
export * from "./RoomChat.vue?vue&type=script&lang=js&"
import style0 from "./RoomChat.vue?vue&type=style&index=0&id=1ad108a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad108a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ad108a6')) {
      api.createRecord('1ad108a6', component.options)
    } else {
      api.reload('1ad108a6', component.options)
    }
    module.hot.accept("./RoomChat.vue?vue&type=template&id=1ad108a6&scoped=true&", function () {
      api.rerender('1ad108a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Chat/RoomChat.vue"
export default component.exports